export default __webpack_public_path__ + "static/media/Shot_13.0000.89a0e470.png";